import LK_Import from '../../images/LK_Import';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { styled } from '@mui/material/styles';
import {Box,Button, Divider} from '@mui/material';
import Papa from "papaparse";
import { min } from 'moment';
import { use } from 'echarts';
import CustomTooltip from './CustomTooltip.js';

/* 
headerList (string array) :It is array of string which contains the name of header of each column in csv.
data (object array) : Array of objects with each object containing the data of single row inn csv.
fileName (string) : Name of the csv file that is being exported.
fieldList (string array) : Array of string containing names of properties of the object.
*/

export default function CustomImportButton({data,fileName,headerList,fieldList,width,setData}) {

    const VisuallyHiddenInput = styled('input')({
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(50%)',
        height: 1,
        overflow: 'hidden',
        position: 'absolute',
        bottom: 0,
        left: 0,
        whiteSpace: 'nowrap',
        width: 1,
      });

    const [csvData, setCsvData] = useState([]);

    // useEffect(() => {
    //     setData(csvData)
    // }, [csvData]);
    
    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            const maxSize = 50 * 1024 * 1024; // Example: 50MB limit
            if (file.size > maxSize) {
                alert("File is too large! Please select a file smaller than 50MB.");
                return;
            }
            Papa.parse(file, {
                header: true, // Set to true if the CSV has headers
                skipEmptyLines: true,
                complete: (result) => {
                    setCsvData(result.data); // Save parsed data to state
                    setData(result.data)
                },
                error: (error) => {
                    console.error("Error parsing CSV:", error);
                },
            });
        }
    };

    return (
        // <div>
        //     <input type="file" accept=".csv" onChange={handleFileUpload} />
        //     {/* <div>
        //         <h4>Parsed Data:</h4>
        //         <pre>{JSON.stringify(csvData, null, 2)}</pre>
        //     </div> */}
            
        // </div>
    <CustomTooltip title={"Import"} offset={[30,-20]} placement={'right-end'}>
        <Button
            component="label"
            role={undefined}
            style={{
                borderRadius: 0,
                backgroundColor: 'none',
                padding: "0",
                minWidth:width?width:'auto',
            }}
            tabIndex={-1}
        >
            <LK_Import color='var(--LK_BrandBlue)' width={"28px"} height={"28px"}/>
            <VisuallyHiddenInput
                type="file"
                accept=".csv"
                onChange={handleFileUpload}
                // multiple
            />
        </Button>
    </CustomTooltip>
    )
}